import React from "react"

//paymentimage
import paymentimage from '../assets/images/payment.png'

const Footer = () => {
    return (
      <>
      {/*
    - FOOTER
  */}
  <footer>
    <div className="footer-category">
      <div className="container">
        <h2 className="footer-category-title">Brand directory</h2>
        <div className="footer-category-box">
          <h3 className="category-box-title">Fashion :</h3>
          <a href="index.html#" className="footer-category-link">
            T-shirt
          </a>
          <a href="index.html#" className="footer-category-link">
            Shirts
          </a>
          <a href="index.html#" className="footer-category-link">
            shorts &amp; jeans
          </a>
          <a href="index.html#" className="footer-category-link">
            jacket
          </a>
          <a href="index.html#" className="footer-category-link">
            dress &amp; frock
          </a>
          <a href="index.html#" className="footer-category-link">
            innerwear
          </a>
          <a href="index.html#" className="footer-category-link">
            hosiery
          </a>
        </div>
        <div className="footer-category-box">
          <h3 className="category-box-title">footwear :</h3>
          <a href="index.html#" className="footer-category-link">
            sport
          </a>
          <a href="index.html#" className="footer-category-link">
            formal
          </a>
          <a href="index.html#" className="footer-category-link">
            Boots
          </a>
          <a href="index.html#" className="footer-category-link">
            casual
          </a>
          <a href="index.html#" className="footer-category-link">
            cowboy shoes
          </a>
          <a href="index.html#" className="footer-category-link">
            safety shoes
          </a>
          <a href="index.html#" className="footer-category-link">
            Party wear shoes
          </a>
          <a href="index.html#" className="footer-category-link">
            Branded
          </a>
          <a href="index.html#" className="footer-category-link">
            Firstcopy
          </a>
          <a href="index.html#" className="footer-category-link">
            Long shoes
          </a>
        </div>
        <div className="footer-category-box">
          <h3 className="category-box-title">jewellery :</h3>
          <a href="index.html#" className="footer-category-link">
            Necklace
          </a>
          <a href="index.html#" className="footer-category-link">
            Earrings
          </a>
          <a href="index.html#" className="footer-category-link">
            Couple rings
          </a>
          <a href="index.html#" className="footer-category-link">
            Pendants
          </a>
          <a href="index.html#" className="footer-category-link">
            Crystal
          </a>
          <a href="index.html#" className="footer-category-link">
            Bangles
          </a>
          <a href="index.html#" className="footer-category-link">
            bracelets
          </a>
          <a href="index.html#" className="footer-category-link">
            nosepin
          </a>
          <a href="index.html#" className="footer-category-link">
            chain
          </a>
          <a href="index.html#" className="footer-category-link">
            Earrings
          </a>
          <a href="index.html#" className="footer-category-link">
            Couple rings
          </a>
        </div>
        <div className="footer-category-box">
          <h3 className="category-box-title">cosmetics :</h3>
          <a href="index.html#" className="footer-category-link">
            Shampoo
          </a>
          <a href="index.html#" className="footer-category-link">
            Bodywash
          </a>
          <a href="index.html#" className="footer-category-link">
            Facewash
          </a>
          <a href="index.html#" className="footer-category-link">
            makeup kit
          </a>
          <a href="index.html#" className="footer-category-link">
            liner
          </a>
          <a href="index.html#" className="footer-category-link">
            lipstick
          </a>
          <a href="index.html#" className="footer-category-link">
            prefume
          </a>
          <a href="index.html#" className="footer-category-link">
            Body soap
          </a>
          <a href="index.html#" className="footer-category-link">
            scrub
          </a>
          <a href="index.html#" className="footer-category-link">
            hair gel
          </a>
          <a href="index.html#" className="footer-category-link">
            hair colors
          </a>
          <a href="index.html#" className="footer-category-link">
            hair dye
          </a>
          <a href="index.html#" className="footer-category-link">
            sunscreen
          </a>
          <a href="index.html#" className="footer-category-link">
            skin loson
          </a>
          <a href="index.html#" className="footer-category-link">
            liner
          </a>
          <a href="index.html#" className="footer-category-link">
            lipstick
          </a>
        </div>
      </div>
    </div>
    <div className="footer-nav">
      <div className="container">
        <ul className="footer-nav-list">
          <li className="footer-nav-item">
            <h2 className="nav-title">Popular Categories</h2>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Fashion
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Electronic
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Cosmetic
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Health
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Watches
            </a>
          </li>
        </ul>
        <ul className="footer-nav-list">
          <li className="footer-nav-item">
            <h2 className="nav-title">Products</h2>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Prices drop
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              New products
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Best sales
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Contact us
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Sitemap
            </a>
          </li>
        </ul>
        <ul className="footer-nav-list">
          <li className="footer-nav-item">
            <h2 className="nav-title">Our Company</h2>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Delivery
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Legal Notice
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Terms and conditions
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              About us
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Secure payment
            </a>
          </li>
        </ul>
        <ul className="footer-nav-list">
          <li className="footer-nav-item">
            <h2 className="nav-title">Services</h2>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Prices drop
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              New products
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Best sales
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Contact us
            </a>
          </li>
          <li className="footer-nav-item">
            <a href="index.html#" className="footer-nav-link">
              Sitemap
            </a>
          </li>
        </ul>
        <ul className="footer-nav-list">
          <li className="footer-nav-item">
            <h2 className="nav-title">Contact</h2>
          </li>
          <li className="footer-nav-item flex">
            <div className="icon-box">
              <ion-icon name="location-outline" />
            </div>
            <address className="content">
              419 State 414 Rte Beaver Dams, New York(NY), 14812, USA
            </address>
          </li>
          <li className="footer-nav-item flex">
            <div className="icon-box">
              <ion-icon name="call-outline" />
            </div>
            <a href="tel:+607936-8058" className="footer-nav-link">
              (607) 936-8058
            </a>
          </li>
          <li className="footer-nav-item flex">
            <div className="icon-box">
              <ion-icon name="mail-outline" />
            </div>
            <a href="mailto:example@gmail.com" className="footer-nav-link">
              example@gmail.com
            </a>
          </li>
        </ul>
        <ul className="footer-nav-list">
          <li className="footer-nav-item">
            <h2 className="nav-title">Follow Us</h2>
          </li>
          <li>
            <ul className="social-link">
              <li className="footer-nav-item">
                <a href="index.html#" className="footer-nav-link">
                  <ion-icon name="logo-facebook" />
                </a>
              </li>
              <li className="footer-nav-item">
                <a href="index.html#" className="footer-nav-link">
                  <ion-icon name="logo-twitter" />
                </a>
              </li>
              <li className="footer-nav-item">
                <a href="index.html#" className="footer-nav-link">
                  <ion-icon name="logo-linkedin" />
                </a>
              </li>
              <li className="footer-nav-item">
                <a href="index.html#" className="footer-nav-link">
                  <ion-icon name="logo-instagram" />
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="container">
        <img
          src={paymentimage}
          alt="payment method"
          className="payment-img"
        />
        <p className="copyright">
          Copyright © <a href="index.html#">Aura Alley</a> all rights reserved.
        </p>
      </div>
    </div>
  </footer>
      </>
    );
  }
  export default Footer;